import { useEffect, useRef } from "react";
import { api } from "@/lib/api";

export default function useLocationShare() {
  const lastSent = useRef(0);
  const lastPos = useRef(null);

  useEffect(() => {
    let watchId = null;
    let cancelled = false;

    const dist = (a, b) => {
      const R = 6371000, dLat = ((b.lat - a.lat) * Math.PI) / 180, dLng = ((b.lng - a.lng) * Math.PI) / 180;
      const s = Math.sin(dLat / 2) ** 2 + Math.cos((a.lat * Math.PI) / 180) * Math.cos((b.lat * Math.PI) / 180) * Math.sin(dLng / 2) ** 2;
      return 2 * R * Math.asin(Math.sqrt(s));
    };

    const send = async (pos) => {
      const p = { lat: pos.coords.latitude, lng: pos.coords.longitude, accuracy: pos.coords.accuracy };
      const now = Date.now();
      if (now - lastSent.current < 30000 && lastPos.current && dist(lastPos.current, p) < 30) return;
      lastSent.current = now;
      lastPos.current = p;
      let battery = null;
      try {
        if (navigator.getBattery) battery = Math.round((await navigator.getBattery()).level * 100);
      } catch {}
      api.post("/location", { ...p, battery }).catch(() => {});
    };

    api.get("/family").then((r) => {
      if (cancelled || !r.data.family || !navigator.geolocation) return;
      watchId = navigator.geolocation.watchPosition(send, () => {}, {
        enableHighAccuracy: true, maximumAge: 10000, timeout: 20000,
      });
    }).catch(() => {});

    return () => {
      cancelled = true;
      if (watchId != null) navigator.geolocation.clearWatch(watchId);
    };
  }, []);
}
